/** Ensure portal URLs are absolute for storage and display. */
export function normalize_portal_url(url: string): string {
  const trimmed = url.trim()
  if (!trimmed) return trimmed
  return trimmed.startsWith("http") ? trimmed : `https://${trimmed}`
}

if (import.meta.vitest) {
  const { describe, it, expect } = import.meta.vitest

  describe("normalize_portal_url", () => {
    it("prepends https when scheme is missing", () => {
      expect(normalize_portal_url("portal.example.com")).toBe("https://portal.example.com")
    })

    it("preserves existing https URLs", () => {
      expect(normalize_portal_url("https://portal.example.com")).toBe("https://portal.example.com")
    })
  })
}
